import React, { useState, useEffect } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { useSelector, useDispatch } from "react-redux";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { Cookies } from "react-cookie";
export const BtnXuatDanhSach = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dataSearch = useSelector((state) => state.dataSearchKiemKho);
  const xuatExcel = () => () => {

    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }

    link = link +
      `quan-ly-tai-san/danh-sach-kiem-kho-xuat-excel?kho=${dataSearch.kho}&trangThai=${dataSearch.trangThai}`;
    API_AUTH.get(link).then((res) => {

      var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = "KiemKho_" + new Date().getDate() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear() + "-" + new Date().getHours() + "-" + new Date().getMinutes() + "-" + new Date().getSeconds() + ".xls";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };

  return (
    <>
      <a href={() => false} className="icon-bgnew color-print1" onClick={xuatExcel()}>
        <PopoversBootrap
          contentText="Xuất danh sách"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
           <img src="/app-assets/images/icon-tai-xuong-v2.png" />
        </PopoversBootrap>
      </a>
    </>
  );
};
